import { numberParser } from './numberParser'
import { postalCodesVTEX } from '../constants/states'
import { ONLY_CHECKOUT } from '../constants/stores'
import CryptoJS from 'crypto-js'

export const transformCart = items => {
  const lines = []
  items.forEach(item => {
    lines.push({
      id: `${item.item_id}`,
      productName: item.name,
      productImage: item.thumbnail,
      quantity: parseInt(item.qty),
      lineTotal: numberParser(item.price_incl_tax)
    })
  })
  return lines
}

export const transformCartTotals = data => {
  return {
    subtotal: data.base_subtotal_incl_tax || data.subtotal_incl_tax,
    total: data.base_subtotal_incl_tax || data.subtotal_incl_tax,
    itemsCount: data.items_qty
  }
}

export const scrollToTop = () => {
  const scrollers = document.getElementsByClassName('list-item-div')
  const arrayScrollers = [...scrollers]
  arrayScrollers.forEach((scroller) => {
    scroller.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })
}

export const scrollToBottom = () => {
  const scroll = document.getElementsByClassName('div-user-form')
  scroll[0].scrollTo({
    top: scroll[0].scrollHeight,
    behavior: 'smooth'
  })
}

export const totalPriceParser = (items) => {
  const totalPrice = items?.reduce((a, b) => { return { final_line_price: a.final_line_price + b.final_line_price } })
  return totalPrice.final_line_price / 100
}

export const abreviatedCartLines = (cartLines) => {
  if (!cartLines || Object.keys(cartLines).length === 0) return []
  return cartLines.map(line => {
    return { variantId: `${btoa(`gid://shopify/ProductVariant/${line?.variantId}`)}`, quantity: line.quantity }
  })
}

export const onlyLetters = (value) => {
  const result = value.replace(/[^a-zA-Z \-áéíóúÁÉÍÓÚñÑ`'´,.]/gi, '')
  return result
}

export const onlyNumbers = (value) => {
  const result = value.replace(/[^\d]/g, '')
  return result
}

export const noSpecialCharacters = (value) => {
  const result = value.replace(/[^\w\d\-.@]/g, '')
  return result
}

export const onlySomeNumbers = (value) => {
  const result = value.match(/\d{10,}/g)
  if (result) {
    return result[0].match(/\d{9}/)[0]
  }
  return value
}

export const onlySomeLetters = (value, quantity) => {
  const preliminarResult = value.replace(/[^a-zA-Z\d\s\-ñÑáéíóúÁÉÍÓÚ.`',]/g, '')
  const result = preliminarResult.match(new RegExp(`[\\d\\w\\s\\S]{${quantity + 1},}`, 'g'))
  if (result) {
    return result[0].match(new RegExp(`[\\d\\w\\s\\S]{${quantity}}`))[0]
  }
  return preliminarResult
}

export const camelToSnake = (str) => (str.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`))

export const itemsUrlParser = (items) => {
  return items
    .map((item) => `${item.variantId}:${item.quantity}`)
    .join(',')
}

export const setServiceAndShippingcost = (selectedService, setterService, setterCart, cartData) => {
  setterService(selectedService)
  setterCart(prevState => {
    return {
      ...prevState,
      shippingCost: selectedService.price,
      total: (cartData.subtotal || 0) + selectedService.price
    }
  })
}

export const getPinflagApiKey = () => {
  const searchParams = new URLSearchParams(document.location.search)
  return searchParams.get('token') || process.env.REACT_APP_API_KEY
}

export const getOrderFormId = () => {
  const searchParams = new URLSearchParams(document.location.search)
  return searchParams.get('orderFormId')
}

const removeAccents = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const getPostalCode = (district) => {
  const parsedDistrict = removeAccents(district.toLowerCase())
  return postalCodesVTEX[parsedDistrict]
}

export const getTotalPriceSLA = (logisticInfo, index) => {
  const totalPrice = logisticInfo.reduce((acc, currentValue) => acc + currentValue.slas[index].price, 0)
  return totalPrice / 100
}

export const getPinflagPostalCode = (price) => {
  const priceLength = `${price}`.length
  return price === 0 ? '0030001' : '0'.repeat(7 - priceLength) + `${price}`
}

export const parseDeliveryTime = (oldDeliveryTime) => {
  const time = oldDeliveryTime.slice(0, oldDeliveryTime.indexOf('bd'))
  const info = oldDeliveryTime.slice(oldDeliveryTime.indexOf(time) + time.length)
  const infoTranslate = { h: 'horas hábiles', bd: 'días hábiles' }
  return `Máximo ${time} ${infoTranslate[info]}`
}

export const translateDeliveryType = (companyName) => {
  if (ONLY_CHECKOUT.includes(companyName)) return 'residential'
  return 'Despacho a Domicilio'
}

export const translateDeliveryTypeBack = (type) => {
  if (type === 'residential') return 'Despacho a Domicilio'
  return type
}

export const encryptToken = (token, key) => {
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(token, key, { iv })

  const combined = iv.toString() + encrypted.toString()

  return combined
}

export const decryptToken = (encrypted, key) => {
  const iv = CryptoJS.enc.Hex.parse(encrypted.slice(0, 32))

  const encryptedToken = encrypted.slice(32)

  const decrypted = CryptoJS.AES.decrypt(encryptedToken, key, { iv })

  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const splitStringIntoTwoParts = (text) => {
  const arrayText = text.split(' ')
  const firstPart = arrayText.length > 1 ? arrayText.slice(0, -1).join(' ') : arrayText[0]
  const secondPart = arrayText.length > 1 ? arrayText[arrayText.length - 1] : '.'
  return [firstPart, secondPart]
}
